var scope_0 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5d35d002a597e4056370123ef3b3d9ad.js').default;
var scope_1 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a176bd1354ff871bbb85c6f695f6abf7.js').default;
var scope_2 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ecdcfd9b975aa22ed78880057978fe48.js').default;
var scope_4 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0a069e1ce855643f60f8f9ae18c4be2.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    